/* eslint-disable @typescript-eslint/typedef */
import { createSlice } from '@reduxjs/toolkit';

import {
  AccountabilityState,
  SetAccountabilityTemplatePayload,
  SetLeaderboardPayload,
  SetTeamLeaderboardPayload
} from '../../../types/state/accountablity.types';

export const initialState: AccountabilityState = {
  accountabilityTemplate: undefined,
  leaderboard: undefined,
  teamLeaderboard: undefined
};

const AccountabilitySlice = createSlice({
  name: 'accountability',
  initialState,
  reducers: {
    setAccountabilityTemplate: (state, action: SetAccountabilityTemplatePayload): void => {
      state.accountabilityTemplate = action.payload;
    },
    setLeaderboard: (state, action: SetLeaderboardPayload): void => {
      state.leaderboard = action.payload;
    },
    setTeamLeaderboard: (state, action: SetTeamLeaderboardPayload): void => {
      state.teamLeaderboard = action.payload;
    }
  }
});

export const { setAccountabilityTemplate, setLeaderboard, setTeamLeaderboard } = AccountabilitySlice.actions;

export default AccountabilitySlice.reducer;
